import React from "react";
import PropTypes from "prop-types";

import { useQuery } from "react-apollo";
import gql from "graphql-tag";

import "./VerifiedBy.scss";

const SINGLE_USER_QUERY = gql`
  query User($where: UserWhereUniqueInput!) {
    User(where: $where) {
      RecId
      FirstName
      LastName
      UserId
    }
  }
`;
const VerifiedBy = ({ verifiedByRecIdRef }) => {
  const { data = {}, loading } = useQuery(SINGLE_USER_QUERY, {
    variables: {
      where: {
        RecId: parseInt(verifiedByRecIdRef)
      }
    }
  });

  if (loading) {
    return "Loading";
  }

  const verifiedBy = data.User?.UserId ?? "Unknown";
  return (
    <div className="verified-by">
      <span>
        <b>
          <em>Verified By</em>
        </b>
      </span>
      &nbsp;
      <span>{verifiedBy}</span>
    </div>
  );
};

VerifiedBy.propTypes = {
  verifiedByRecIdRef: PropTypes.string
};

export default VerifiedBy;
